import ToolMark from '../../tools/ToolMark';
// Toggles a bold mark on the currently selected elements.

class ToolBold extends ToolMark {
  static toolName = 'Bold';
  static iconClass = 'fa-regular fa-bold';
  static mark = 'bold' as const;
  static shortcut = 'Cmd+b';
  static ariaLabel = 'Bold';
}

export default ToolBold;
